import { Injectable } from '@angular/core';
import { createSelector, Selector } from '@ngxs/store';
import { IPlanState, PlansState } from '@nibtravel/shared/data-access/plans';
import { IQuoteInput, QuoteState } from '@nibtravel/shared/data-access/quote';

import { BrandContentMap, IUiContentState } from '../models';
import { UiContentState } from './ui-content.state';

@Injectable({ providedIn: 'root' })
export class UiContentSelector {
  @Selector([QuoteState.quoteInput, PlansState.getState])
  static getUnderwriterCode(
    quote: IQuoteInput,
    planState: IPlanState
  ): string | undefined {
    return quote.planId && planState.planSummaries
      ? planState.planSummaries[quote.planId].underwriterCode
      : undefined;
  }

  @Selector([UiContentState])
  static getBrandContents(state: IUiContentState): BrandContentMap {
    return state.brandContent;
  }

  @Selector([UiContentSelector.getBrandContents])
  static getBrandContentByType(
    contentItems: Record<string, string>,
    type: string
  ): string {
    return contentItems[type];
  }

  public static translation(key: string) {
    return createSelector([UiContentState], (state: IUiContentState) => {
      return state?.brandContent[key];
    });
  }
}
